export const JOURNAL_PROMPTS = [
  "What I'm not saying out loud is…",
  "The part of me that is tired wants…",
  "If I could write without evaluating myself, I would say…",
  "Today, what I actually need is…",
  "A small truth I'm willing to admit:",
  "What's underneath the urge I keep feeling?",
  "Who in my life feels safe right now? Why?",
  "One thing I'd say to my younger self today:",
  "The next honest step is…",
];

export const randomPrompt = () =>
  JOURNAL_PROMPTS[Math.floor(Math.random() * JOURNAL_PROMPTS.length)];
